export default __webpack_public_path__ + "static/media/PhantomSans0.8-Medium.a07682fd.ttf";